import type { ThemeDefaults } from '@nuxt/ui'

/**
 * The prop defaults every Nuxt UI component in this portal starts from, handed to
 * `<UTheme>` at the root of App.vue. A component that names the prop itself still wins.
 *
 * ## form.validateOn
 *
 * A form validates a field once somebody has CHANGED it, and again on submit — never on
 * mount, and never on the blur of a field nobody typed in. Nuxt UI's own default is
 * `['input', 'blur', 'change']`, and the blur in it is what turns a required field red
 * for merely reaching past it: a dialog opens with its first field focused, somebody
 * clicks the button beside it, and the name they have not been asked for yet is already
 * marked wrong. A red field has to mean the person got something wrong, not that the
 * dialog opened.
 *
 * It is here rather than on each `<UForm>` because it is the house's answer and not one
 * screen's. It used to be written out as `:validate-on="['change']"` on forty forms
 * across the portals — forty places for the next one to be forgotten in, and about
 * sixty more forms that never carried it at all.
 */
export const uiDefaults: ThemeDefaults = {
    form: {
        validateOn: ['change'],
    },
}
